var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tab',[(!_vm.$constants.isDemo)?_c('TabItem',{attrs:{"id":"user","active":_vm.active,"to":{
      name: 'configUser'
    }}},[_vm._v("\n    ユーザー情報\n  ")]):_vm._e(),(_vm.organization.organizationId)?[_c('TabItem',{attrs:{"id":"contract","active":_vm.active,"to":{
        name: 'configContract'
      }}},[_vm._v("\n      利用情報\n    ")]),(_vm.isDelegate && _vm.isStripe)?_c('TabItem',{attrs:{"id":"payment","active":_vm.active,"to":{
        name: 'configPayment'
      }}},[_vm._v("\n      請求書 & 支払い\n    ")]):_vm._e(),(_vm.isAuthority)?_c('TabItem',{attrs:{"id":"management","active":_vm.active,"to":{
        name: 'configManagement'
      }}},[_vm._v("\n      ユーザー管理\n    ")]):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }